import "./styles/userManual.css";
import { Link } from 'react-router-dom';

function UserManual() {
  return (
    <div className="user-manual">
      <h1 className="self">User Manual!</h1>
      <p className="swot-content">
        This manual provides a comprehensive overview of Abdur. It captures how I operate in a
        team, how I think through{" "}
        <b className="bold">
          {" "}
          problems, what drives me, and how to get the best out of working with
          me.
        </b>
      </p>
      <h1 className="swot">🔥Strength</h1>
      <p className="swot-content">
        Focused when given tasks, naturally sharp and alert, highly curious
        about trends and real-world problem-solving. Thrive in fast-paced
        environments and adapt quickly to new challenges.
      </p>
      <h1 className="swot">👎Weakness</h1>
      <p className="swot-content">
        Prone to procrastination and distractions. I'm actively overcoming it
        using the Pomodoro technique and setting tighter daily goals to stay
        consistent and productive.
      </p>
      <h1 className="swot">✨Oppurtunity</h1>
      <p className="swot-content">
        Collaborate with me and you’ll have the honor of navigating my
        never-ending curiosity, which often results in asking "why" about
        everything that’s “obviously” working.
      </p>
      <h1 className="swot">🔪Threats</h1>
      <p className="swot-content">
        Overthinking the past and spreading myself thin can block momentum -
        frustration often stops me before I regain clarity. I’m learning to
        prioritize and detach emotionally from delays to keep moving forward.
      </p>

      <h1 className="self fq">🪄 Favourite Quotes</h1>
      <p className="swot-content fq-content">
      "The people who are crazy enough to think they can change the world are the ones who do." — <b className="bold"> Steve Jobs </b>
      </p>
      <Link to="/contact" className="more" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
        Get in touch ⟶
      </Link>
    </div>
  );
}

export default UserManual;
